import { render, staticRenderFns } from "./sos.vue?vue&type=template&id=6b585e45"
import script from "./sos.vue?vue&type=script&lang=js"
export * from "./sos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports